// transfers
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";
import WebbSpinner from "../webx/webb-spinner";
import WebbModuleInfo from "../webx/webb-module-info";
import FormNeeded from "../webx/form-needed";

import { GetLocalUser } from "../../services/srvc-user-local";

import { CoinRatesList } from "../../services/srvc-coinrates-realm";

import { TransferxCreate } from "../../services/srvc-transfers-realm";

const creditmode = ['usd', 'eur', 'inr' ]
const debitmode = [ 
  {name: 'Card', code: 'card-strix', actv: true }, 
  {name: 'FIL', code: 'web3-fil', actv: true },
  {name: 'Matic', code: 'web3-matic', actv: true }, 
  {name: 'BNB', code: 'web3-binance', actv: true }, 
  {name: 'Celo', code: 'web3-celo', actv: true }, 
  {name: 'UPI', code: 'fiat-upix', actv: false }, 
]

export default function TransfersFilecoinModule () {

  const navigate = useNavigate();
  const asset = {form: 'ww'}  //GetLocalUser()
  
  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [done, setDone] = useState(false);

  const [form, setForm] = useState(false);
  const [memo, setMemo] = useState('');

  const [link, setLink] = useState('')  
  const [ticker, setTicker]= useState(['card-strix'])
  const [ratesUSD, setRatesUSD] = useState(1) 
  const [ratesEUR, setRatesEUR] = useState(1) 
  const [ratesINR, setRatesINR] = useState(1) 
  const [data, setData] = useState({
    creditname: 'FVM Dataverse',
    creditmail: 'finnovateinc+fvm@gmail.com',
    creditticker: 'usd',
    debitname: 'Smriti',
    debitmail: 'smriti@route.bz',
    count: '0',
    amount: '0',
    memo: 'FVM Dataverse Hack Demo'
  })

  useEffect( () => {
    if (asset){

      const fetchData = async() => {
        setLoading(true);

        var result = (await CoinRatesList({data: {ticker: 'usd'}})).data
        setRatesUSD(parseFloat(result.rates.find( x => x.code==='celo').rate))
        
        var result = (await CoinRatesList({data: {ticker: 'eur'}})).data
        setRatesEUR(parseFloat(result.rates.find( x => x.code==='celo').rate))        

        var result = (await CoinRatesList({data: {ticker: 'inr'}})).data
        setRatesINR(parseFloat(result.rates.find( x => x.code==='celo').rate)) 

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);


  useEffect( () => {
    const fetchData = async() => {
      if (data.creditticker === 'usd') handleChange('amount', (data.count*3.249*ratesUSD).toFixed(6))
      if (data.creditticker === 'eur') handleChange('amount', (data.count*3.249*ratesEUR).toFixed(6))
      if (data.creditticker === 'inr') handleChange('amount', (data.count*3.249*ratesINR).toFixed(6))
    }
    fetchData()
  },[data.count, data.creditticker]);

  // useEffect for form validation
  useEffect( () => {
    setForm(false);
    if (data.debitname !=='' && data.debitmail !=='' && data.amount > 0) setForm(true);

  },[data]);




  const handleSubmit = async () => {

    setLoading(true);
    setSubmit(true);

    const basedomain = window.location.host.split(':')[0] === 'localhost' ? `http://${window.location.host}` : `https://${window.location.host}`

    const datx = {
      credit: { name: data.creditname, user: data.creditmail },
      debit: { name: data.debitname, user: data.debitmail },
      sale: {amount: data.amount, ticker: data.creditticker === "" ? 'usd' : data.creditticker},
      asset: { name: "", memo:"", number: ""},
      media: { link: "", mime: ""}, 
      memo: data.memo, number: '******',
      tickers: ticker === [] ? ['card-strix', 'web3-celo']: ticker, mode: 'testnet', 
      link: {
        success: 'https://route33e40eaa.web.app/success', 
        failed: 'https://route33e40eaa.web.app/failed'
      }, 
      domain: basedomain
    }

    console.log(datx)

    const result = await TransferxCreate({data: datx})
    console.log (result)
    
    if (result.data) {
      setDone(true)
      setMemo('Transfer Created.')
      setLink(result.data.link)
    }
    else {
      setDone(false)
      setMemo('Failed.')
    }

    setLoading(false)
    
  }

  const handleTicker = async(item) => {
    console.log (item)
    const index = ticker.findIndex(x => x=== item)
    console.log(index)
    if (index === -1) {
      console.log([...ticker, item])
      setTicker([...ticker, item])
    } else {
      console.log ([...ticker.splice(index,1)])
      setTicker([...ticker.splice(index,1)])
    }
  }

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }



  // if (loading) return <></>


  return (
  <>
    
    <div className="p-2 px-3 rounded-wd back-color-wite border">
      <div className="d-flex justify-content-between">
        <div className="">
          <img src='https://filecoin.io/images/filecoin-logo.svg' 
            className="mt-1"
            width={24}
            alt='route'></img>
        </div>
        <div className="">
          <p className="m-0 mt-1">Get FIL Tokens</p>
        </div>
        <div className="text-end">
          <i className={`bx bx-user-circle text-icon-sm`}></i>
        </div>
      </div>
    </div>

    <WebbDividerMedium />  
    <div className="row">
      <div className="col-md-6">
      <div className="">
        <p className="text-color-tone">1: User Details</p>
        <div className="mb-3">  
          <label className="form-label small">Name <FormNeeded/></label>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.debitname}
            onChange={({ target }) => {handleChange("debitname", target.value); }}
            disabled={loading || submit}
            placeholder="user name">
          </input>
        </div>

        <div className="mb-3">  
          <label className="form-label small">Email <FormNeeded/></label>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.debitmail}
            onChange={({ target }) => {handleChange("debitmail", target.value); }}
            disabled={loading || submit}
            placeholder="fvm@route.bz">
          </input>
        </div>
      </div>
      </div>

      <div className="col-md-6">
      <div className="">
        <p className="text-color-tone">2: Transfer Details</p>
        <div className="mb-3">  
          <label className="form-label small">Amount (FIL)<FormNeeded/></label>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.count}
            onChange={({ target }) => {handleChange("count", target.value); }}
            disabled={loading || submit}
            placeholder="">
          </input>
        </div>
        <p className="text-small text-color-tone d-none">rates via Tellor</p>
      </div>

      <div className="mb-3">  
          <label className="form-label small">Reason <FormNeeded/></label>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.memo}
            onChange={({ target }) => {handleChange("memo", target.value); }}
            disabled={loading || submit}
            placeholder="user name">
          </input>
        </div>      

      <div className="border-bottom d-none"></div>
      <WebbDividerSmall />
      <div className="">
        <p className="text-color-tone d-none">3: Transfer Details</p>
        <div className="mb-3">  
          <label className="form-label small">Amount (User) <FormNeeded/></label>
          <p className="text-small text-color-tone mb-2">rates via Tellor</p>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.amount}
            onChange={({ target }) => {handleChange("amount", target.value); }}
            disabled={true || loading || submit}
            placeholder="">
          </input>
        </div>

        <div className="mb-3">  
          <label className="form-label small d-none">Currency <FormNeeded/></label>
          {creditmode && creditmode.map((item, i) => (
            <span className="me-1" key={i}>
              <span className={`${data.creditticker === item ? 'back-color-rich' : 'back-color-wite'} p-2 px-3  border rounded-wd text-uppercase text-small cursor hirich`}
                onClick={()=> handleChange('creditticker', item)}
              >{item}</span>
            </span>
          ))}
        </div>

        <WebbDividerSmall />
        <div className="mb-3">  

          <label className="form-label small">Users Payment Options (Select Multiple) <FormNeeded/></label>
          <div className="mb-3 mt-2">
          {debitmode && debitmode.map((item, i) => ( item.actv ?
            <span className="me-1" key={i}>
              <span className={`${ticker.includes(item.code) ? 'back-color-rich' : 'back-color-wite'} p-2 px-3 border rounded-wd text-uppercase text-small cursor hirich`}
                onClick={()=> handleTicker(item.code)}
              
              >{item.name}</span>
            </span>
          :''))}
        </div>
        </div>


      </div>


      </div>

      
    </div>

    <div className={!loading && submit && done ? 'd-none' : 'mx-3'}>

      <div className="d-none">
        <p className="text-color-tone">1: Credit</p>
        <div className="mb-3">  
          <label className="form-label small">Your Name <FormNeeded/></label>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.creditname}
            onChange={({ target }) => {handleChange("creditname", target.value); }}
            disabled={loading || submit}
            placeholder="user name">
          </input>
        </div>

        <div className="mb-3">  
          <label className="form-label small">Your Email <FormNeeded/></label>
          <input type="text" className="form-control height-md  "
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.creditmail}
            onChange={({ target }) => {handleChange("creditmail", target.value); }}
            disabled={loading || submit}
            placeholder="credit@route.bz">
          </input>
        </div>
      </div>

    </div>

    <WebbDividerMedium />        
    <div className="border-bottom"></div>
    <div className={!loading && submit && done ? '' : 'd-none'}>
      
      <p className="m-0">{memo}</p>
      <p className="m-0">{'You can share the following link to collect payments.'}</p>
      <a href={link} className="text-primary">{link}</a>
      <WebbDividerMedium />
      <p className="cursor text-primary" onClick={() => window.location.reload()}>Make Another Transfer</p>
    </div>    

    
    <div className={loading && submit || done ? 'd-none' : ''}>
      <WebbDividerMedium />
      <div className="d-flex justify-content-between">

        <button className={`btn btn-light border back-color-wite rounded-wd button text-small`}
          type="button"
          onClick={()=> ''}
        >{loading ? 'Please Wait...' : 'Cancel'}</button>

        <button className={`btn btn-info border-none back-color-main text-color-wite rounded-wd text-small`}
          disabled={!form || loading || submit}
          type="button"
          onClick={()=> { handleSubmit()}}
        >{loading ? 'Please Wait...' : 'Continue'}</button>

      </div>
    </div>
    

    <div className={loading && submit ? 'mx-3' : 'd-none'}>
      Please Wait...
    </div>


  </>

  )
}
